import { Modal } from "react-bootstrap";
import { DeleteDigitalSignatureModalProps } from "./DeleteDigitalSignatureModal.types";

export function DeleteDigitalSignatureModal({
  show,
  onCancel,
  onDelete,
}: DeleteDigitalSignatureModalProps) {
  return (
    <Modal show={show} animation onHide={onCancel}>
      <Modal.Header>
        <h5 className="modal-title" id="Delete Modal">
          Delete Digital Signature
        </h5>
        <div onClick={onCancel}>
          <span className="font-20 cursor-pointer">&times;</span>
        </div>
      </Modal.Header>
      <Modal.Body>
        Are you sure you want to delete this digital signature? This action is
        irreversible.
      </Modal.Body>
      <Modal.Footer>
        <button type="button" className="btn btn-secondary" onClick={onCancel}>
          Cancel
        </button>
        <button type="button" className="btn btn-danger" onClick={onDelete}>
          Delete
        </button>
      </Modal.Footer>
    </Modal>
  );
}
